import React from 'react';
import { Keys, locale } from 'src/i18n';
// eslint-disable-next-line vymo-ui/restrict-import
import { CASE, LOAN } from '../constant';
import AuditHistory from './audit';
import Cases from './cases';
import EntityDetails from './details';
import RelatedRecords from './relatedRecords';
import SupervisorReview from './supervisorReview';
import { SUPERVISOR_REVIEW_TAB_KEY } from './supervisorReview/constants';
import Trails from './trails';

export const getDetailTabs = (props, details) => {
  if (props?.revyre) {
    const { workflowType } = props;
    const tabs: any = [];

    tabs.push({
      key: 'details',
      label: locale(Keys.DETAILS),
      children: <EntityDetails {...props} />,
    });

    if (workflowType === CASE) {
      tabs.push({
        key: 'trails',
        label: locale(Keys.ACTIVITIES),
        children: <Trails {...props} />,
      });
    }

    const referredEntityDetails = Array.isArray(details?.referredEntityDetails)
      ? details.referredEntityDetails
      : [];

    if (referredEntityDetails.length) {
      referredEntityDetails.forEach((entity) => {
        if (!entity?.workflowType) {
          return;
        }

        tabs.push({
          key: entity.workflowType,
          label: entity.flowName,
          children:
            workflowType === LOAN && entity.workflowType === CASE ? (
              <Cases {...props} module={{ ...entity }} />
            ) : (
              <RelatedRecords
                {...props}
                module={{
                  ...entity,
                  code: entity.workflowType,
                  name: entity.flowName,
                }}
              />
            ),
        });
      });
    }

    tabs.push({
      key: 'audit_history',
      label: locale(Keys.HISTORY),
      children: <AuditHistory {...props} />,
    });

    if (workflowType === CASE) {
      tabs.push({
        key: SUPERVISOR_REVIEW_TAB_KEY,
        label: locale(Keys.SUPERVISOR_REVIEW),
        children: <SupervisorReview {...props} />,
      });
    }

    return tabs;
  }
  return [];
};
